<template>
  <div>
    <div class="page-header d-flex justify-content-between align-items-start">
      <div>
        <h3>
          <strong v-if="this.isTrashed">Trashed: </strong>
          <strong v-else-if="this.isArchived">Archived: </strong>
          <i class="material-icons">folder</i>
          {{project.name}}
        </h3>
        <small v-if="hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Show Completed Tasks</small>
        <small v-if="!hideComletedTasks" class="pointer" @click="toggleCompletedTasks">Hide Completed Tasks</small>
        <span v-if="this.isTrashed">This folder will be purged from the trash on {{this.purgeDate()}}</span>
      </div>
      <div>
        <i class="material-icons pointer" data-toggle="dropdown">mode_edit</i>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" href="#" data-toggle="modal" :data-target="'#editModal' + project.id">Edit</a>
          <a v-if="this.isArchived" class="pointer dropdown-item text-danger"  @click="unarchiveProject(project)">Unarchive Folder</a>
          <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#deleteModal' + project.id">Archive Folder</a>
          <a v-if="this.isTrashed" class="pointer dropdown-item text-danger"  @click="untrashProject(project)">Remove from Trash</a>
          <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#trashModal' + project.id">Trash Folder</a>
        </div>
      </div>
    </div>
    <TaskExpander />
    <NewComment :project="project"/>
    <NewQuickTask :project="project" :fileCabinet="true" />

    <ul class="mt-2 list-group">
      <draggable v-model="projectTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in projectTasks" :key="task.id" class="list-group-item js-task-details-collapse-container" v-bind:class="{ 'bg-light': task.kind == 'comment' }">
            <QuickTask :task="task" :project="project" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>

    <div class="modal fade" :id="'editModal' + project.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update Folder</h5>
          </div>
          <div class="modal-body">
            <div>
              <div class="form-group row align-items-center">
                <div class="col">
                  <input v-model="project.name" placeholder="Folder Name" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="updateProject(project)">Save</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" :id="'deleteModal' + project.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure you want to archive this folder?</h5>
          </div>
          <div class="modal-body">
            <div> Are you sure you want to archive? -
              <em>
                {{project.name}}
              </em>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="deleteProject(project)">Archive Folder</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" :id="'trashModal' + project.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure you want to trash this folder?</h5>
          </div>
          <div class="modal-body">
            <div> Are you sure you want to trash? -
              <em>
                {{project.name}}
              </em>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="trashProject(project)">Trash Folder</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import NewComment from "components/NewComment";
import TaskExpander from "components/TaskExpander";
import moment from 'moment';
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    NewComment,
    TaskExpander,
    draggable
  },
  data() {
    return {
      project: {},
      hideComletedTasks: true
    };
  },
  created() {
    api.getProject(this.$route.params.id).then(response => {
      this.$store.state.current_project = response.data
      this.project = response.data;
    });
  },
  beforeRouteUpdate(to, from, next) {
    api.getProject(to.params.id).then(response => {
      this.$store.state.current_project = response.data
      this.project = response.data;
    });

    next();
  },
  computed: {
    projectTasks: {
      set: function(value){
        value.forEach(function(item, index){
          api.updateTask(item.id, { sort: index })
        })

        return value;
      },
      get: function(){
        var project_id = this.project.id
        var tasks = this.$store.state.tasks.filter(function (task){
          return (task.project_id === project_id)
        })

        if (this.hideComletedTasks) {
          tasks = tasks.filter(function (task) {
            return (task.completed_at === null)
          })
        }
 
        return tasks.sort(firstBy("sort"))
      }
    },
    project_areas: {
      get() {
        return this.$store.state.project_areas
      }
    },
    isArchived(){
      return this.project.discarded
    },
    isTrashed(){
      return this.project.deleted
    }
  },
  methods: {
    deleteProject(project) {
      api.deleteProject(project.id).then(response => {
        window.location.href = '/'
      });
    },
    unarchiveProject(project) {
      api.undeleteProject(project.id).then(response => {
        window.location.href = '/projects/' + project.id;
      });
    },
    trashProject(project) {
      api.trashProject(project.id).then(response => {
        window.location.href = '/'
      });
    },
    untrashProject(project) {
      api.untrashProject(project.id).then(response => {
        window.location.href = '/projects/' + project.id;
      });
    },
    updateProject(project) {
      api.updateProject(project.id, { name: this.project.name, project_area_id: this.project.project_area_id }).then(response => {
        $('#editModal' + project.id).modal('hide')
      });
    },
    purgeDate(){
      return moment(this.project.deleted_at).add(30, 'days').format("MMMM DD")
    },
    toggleCompletedTasks(){
      this.hideComletedTasks = !this.hideComletedTasks
    }
  }
};
</script>
